import { ControlPaginatedUserResponse } from '@explorer/open-api-client';
import { useV1APIQuery } from '@explorer/query';

export const useQueryUser = (email?: string) => {
  return useV1APIQuery<ControlPaginatedUserResponse>({
    queryKey: ['v1ControlWebAdminUserGet', email],
    queryFn: (client, { signal }) => {
      return client.v1ControlWebAdminUserGet({ email: `${email}` }, { signal });
    },
    retry: false,
    enabled: !!email,
    refetchOnWindowFocus: false,
  });
};
